import type { TyreDetail } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { formatDepth, formatKm, TYRE_EVENT_LABELS } from '../policies/tyre-labels';

type Fitment = TyreDetail['fitments'][number];
type Event = TyreDetail['events'][number];

const when = (iso: string | null) => (iso ? new Date(iso).toLocaleString('en-KE') : 'now');

const FITMENT_COLUMNS: TableColumnsType<Fitment> = [
  { title: 'Vehicle', dataIndex: 'vehicleRegistration', render: (registration: string | null) => registration ?? '—' },
  { title: 'Position', dataIndex: 'positionCode' },
  { title: 'Fitted', dataIndex: 'fittedAt', render: when },
  { title: 'At', dataIndex: 'fittedOdometerKm', render: formatKm },
  { title: 'Removed', dataIndex: 'removedAt', render: when },
  { title: 'At', dataIndex: 'removedOdometerKm', render: formatKm },
];

const EVENT_COLUMNS: TableColumnsType<Event> = [
  { title: 'When', dataIndex: 'occurredAt', render: when },
  { title: 'Event', dataIndex: 'eventType', render: (type: Event['eventType']) => TYRE_EVENT_LABELS[type] },
  {
    title: 'Position',
    key: 'position',
    render: (_, event) => (event.toPositionCode ? `${event.positionCode} → ${event.toPositionCode}` : (event.positionCode ?? '—')),
  },
  { title: 'Odometer', dataIndex: 'odometerKm', render: formatKm },
  { title: 'Tread', dataIndex: 'treadDepthMm', render: formatDepth },
  { title: 'Reason / notes', key: 'notes', render: (_, event) => [event.reason, event.notes].filter(Boolean).join(' — ') || '—' },
];

/** Where the tyre has sat, and everything recorded about it, oldest first. History is never edited: a mistake is corrected by a new entry. */
export function TyreHistory({ tyre }: { tyre: TyreDetail }) {
  return (
    <div className="flex flex-col gap-8">
      <section className="flex flex-col gap-3">
        <h2 className="m-0 text-base font-semibold text-fg">Positions</h2>
        <Table rowKey="id" size="small" dataSource={tyre.fitments} columns={FITMENT_COLUMNS} pagination={false} scroll={{ x: 'max-content' }} />
      </section>
      <section className="flex flex-col gap-3">
        <h2 className="m-0 text-base font-semibold text-fg">History</h2>
        <Table rowKey="id" size="small" dataSource={tyre.events} columns={EVENT_COLUMNS} pagination={false} scroll={{ x: 'max-content' }} />
      </section>
    </div>
  );
}
